<script setup lang="ts">
import { LandingPageFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'

defineProps<{
  entity: LandingPageFieldsFragment
  breadcrumbs?: Link[]
}>()
</script>

<template>
  <SectionHeroHome :entity="entity" />
  <Sections :entity="entity" />
</template>
